


























import { defineComponent } from '@vue/composition-api';

import PanelWithStreamEditorGroup from '@/components/Live/PanelWithStreamEditorGroup.vue';

const Setting = defineComponent({
  components: {
    PanelWithStreamEditorGroup,
  },
  // setup() {},
});

export default Setting;
